export const CUSTOMER_CARE_PHONE = '18004190066';
export const CUSTOMER_CARE_TEL = `tel:${CUSTOMER_CARE_PHONE}`;

export const COMPANY_NAME = 'BlueStone Jewellery and Lifestyle Limited';
export const COMPANY_ADDRESS = '302, Dhantak Plaza, Makwana Road, Marol, Mumbai-59';

export const CUSTOMER_CARE_EMAIL = 'cs@bluestone.com';
export const CUSTOMER_CARE_MAILTO = `mailto:${CUSTOMER_CARE_EMAIL}`;

export const COMPANY_CIN = 'L72900KA2011PLC059678';

export const CURRENT_YEAR = new Date().getFullYear();

